export default "__VITE_ASSET__DbUMQxlL__"